// Site-wide static data
export const COMPANY = {
  name: 'Ponthieu Pose et Rénovation',
  short: 'PPR',
  tagline: 'Serrurerie · Métallerie · Vitrerie · Dépannage',
  address: '49 rue de Ponthieu',
  city: '75008 Paris',
  phone: '07 84 07 55 24',
  phoneTel: '+33784075524',
  email: 'ponthieu.pose.renovation@gmail.com',
  mapEmbed: 'https://www.google.com/maps?q=49+rue+de+Ponthieu+75008+Paris&output=embed',
};

export const NAV_LINKS = [
  { label: 'Accueil', path: '/', testKey: 'linkHome' },
  { label: 'Serrurerie', path: '/serrurerie', testKey: 'linkSerrurerie' },
  { label: 'Métallerie', path: '/metallerie', testKey: 'linkMetallerie' },
  { label: 'Vitrerie', path: '/vitrerie', testKey: 'linkVitrerie' },
  { label: 'Dépannage', path: '/depannage', testKey: 'linkDepannage' },
  { label: 'Réalisations', path: '/realisations', testKey: 'linkRealisations' },
  { label: 'À propos', path: '/a-propos', testKey: 'linkApropos' },
  { label: 'Contact', path: '/contact', testKey: 'linkContact' },
];

// Curated images for the whole site. All Unsplash / Pexels HD.
export const IMG = {
  heroDoor: '/hero-marquise.jpg',
  haussmann2: 'https://images.unsplash.com/photo-1772119065264-490a6ff55e63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxoYXVzc21hbm4lMjBkb29yJTIwcGFyaXN8ZW58MHx8fHwxNzg0Mzg3MjQ0fDA&ixlib=rb-4.1.0&q=85',
  lock: 'https://images.pexels.com/photos/6654805/pexels-photo-6654805.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  brass: 'https://images.unsplash.com/photo-1677951570313-b0750351c461?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxicmFzcyUyMGhhcmR3YXJlJTIwbG9ja3xlbnwwfHx8fDE3ODQzODcyNDR8MA&ixlib=rb-4.1.0&q=85',
  stairs: 'https://images.unsplash.com/photo-1612311408242-3ad94a8832cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxzdGVlbCUyMHN0YWlyY2FzZSUyMG1vZGVybnxlbnwwfHx8fDE3ODQzODcyNDR8MA&ixlib=rb-4.1.0&q=85',
  glassArch: 'https://images.unsplash.com/photo-1509024368907-57294758cfc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxnbGFzcyUyMG1ldGFsJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NDM4NzI0NHww&ixlib=rb-4.1.0&q=85',
  glassBuilding: 'https://images.unsplash.com/photo-1461695008884-244cb4543d74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxnbGFzcyUyMG1ldGFsJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NDM4NzI0NHww&ixlib=rb-4.1.0&q=85',
  welder: 'https://images.unsplash.com/photo-1707064892275-a3088e8240be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwd29ya3Nob3AlMjB3ZWxkaW5nfGVufDB8fHx8MTc4NDM4NzI0NHww&ixlib=rb-4.1.0&q=85',
};

export const SERVICES = [
  {
    slug: 'serrurerie',
    index: '01',
    title: 'Serrurerie',
    kicker: 'Pose · Rénovation · Sécurité',
    baseline: "Serrures multipoints, portes blindées, cylindres haute sûreté et interventions après effraction.",
    homeSubtitle: 'Installation, remplacement et sécurisation de serrures pour les particuliers et les professionnels.',
    hero: '/serrurerie-hero-bg.png',
    cover: '/serrurerie-hero.png',
    highlights: [
      'Installation de serrures',
      'Remplacement de serrures',
      'Serrures multipoints',
      'Portes blindées',
      'Blindage de porte',
      'Cylindres et barillets',
      'Renforcement de portes',
      'Pose de poignées',
      'Contrôle d’accès',
      'Sécurisation après effraction',
      'Ouverture de porte',
      'Réparation de serrure',
    ],
    faq: [
      { q: "Quels types de serrures installez-vous ?", a: "Serrures multipoints A2P*, *, ou ***, cylindres européens haute sûreté, contrôle d’accès mécanique ou électronique." },
      { q: "Intervenez-vous après une effraction ?", a: "Oui. Nous sécurisons l’accès, remplaçons les éléments compromis et proposons un blindage adapté." },
      { q: "Le devis est-il gratuit ?", a: "Oui. Le devis est établi après diagnostic sur place ou à partir de photographies détaillées." },
    ],
  },
  {
    slug: 'metallerie',
    index: '02',
    title: 'Métallerie',
    kicker: 'Ouvrages sur mesure',
    baseline: 'Garde-corps, verrières, escaliers, portails et structures métalliques pensés pour durer.',
    homeSubtitle: "Fabrication et pose d’escaliers, garde-corps, structures métalliques et ouvrages sur mesure.",
    hero: '/metallerie-hero-bg.png',
    cover: '/metallerie-hero.png',
    highlights: [
      'Portails métalliques',
      'Garde-corps',
      'Escaliers métalliques',
      'Verrières',
      'Grilles de protection',
      'Rampes',
      'Structures métalliques',
      'Portes métalliques',
      'Mobilier métallique',
      'Réparations',
      'Fabrication sur mesure',
      'Rénovation d’ouvrages métalliques',
    ],
    faq: [
      { q: "Réalisez-vous du sur-mesure intégral ?", a: "Oui. Chaque ouvrage est dessiné, calculé et fabriqué en atelier selon les contraintes du lieu." },
      { q: "Quels aciers utilisez-vous ?", a: "Acier laminé, thermolaqué, brossé ou patiné selon l’usage et l’intégration architecturale souhaitée." },
      { q: "Intervenez-vous en copropriété ?", a: "Régulièrement — garde-corps, portails, cages d’escalier, mises aux normes." },
    ],
  },
  {
    slug: 'vitrerie',
    index: '03',
    title: 'Vitrerie',
    kicker: 'Verre · Vitrage · Miroiterie',
    baseline: "Remplacement de vitrage, double vitrage, verre feuilleté, verrières intérieures et vitrines.",
    homeSubtitle: "Pose, remplacement et réparation de vitrages avec des finitions soignées et durables.",
    hero: '/vitrerie-hero-bg.png',
    cover: '/vitrerie-hero.png',
    highlights: [
      'Remplacement de vitre',
      'Vitrage cassé',
      'Double vitrage',
      'Vitrage de sécurité',
      'Verre feuilleté',
      'Vitrine commerciale',
      'Verrière intérieure',
      'Miroiterie',
      'Découpe sur mesure',
      'Sécurisation provisoire',
      'Remplacement après effraction',
    ],
    faq: [
      { q: "Faites-vous de la sécurisation provisoire ?", a: "Oui, après bris de glace nous posons un panneau de protection en attendant le vitrage définitif." },
      { q: "Quels vitrages sont disponibles ?", a: "Simple, double, feuilleté SP10 ou SP510, dépoli, sablé, teinté — selon usage et esthétique." },
      { q: "Découpez-vous sur mesure ?", a: "Oui, prise de cotes, découpe atelier, façonnage et pose." },
    ],
  },
  {
    slug: 'depannage',
    index: '04',
    title: 'Dépannage',
    kicker: 'Serrurerie · Vitrerie',
    baseline: "Intervention pour portes claquées, clés cassées, serrures bloquées, tentatives d’effraction et bris de glace.",
    homeSubtitle: "Interventions rapides pour les urgences en serrurerie, vitrerie et métallerie, 24h/24 et 7j/7.",
    hero: '/depannage-hero.png',
    cover: '/depannage-hero.png',
    highlights: [
      'Porte claquée',
      'Porte verrouillée',
      'Clé cassée',
      'Clé perdue',
      'Serrure bloquée',
      'Tentative d’effraction',
      'Vitre cassée',
      'Sécurisation urgente',
      'Remplacement rapide',
      'Mise en sécurité des accès',
    ],
    faq: [
      { q: "Quels sont vos horaires ?", a: "Nos horaires d’intervention seront communiqués prochainement. Contactez-nous au 07 84 07 55 24 pour une prise en charge." },
      { q: "Où intervenez-vous ?", a: "Paris et communes environnantes. Zones précises à confirmer avec notre équipe." },
      { q: "Y a-t-il des frais de déplacement ?", a: "Les frais éventuels sont annoncés avant intervention." },
    ],
  },
];

export const MANIFESTO = [
  { n: '01', label: 'Précision', body: "Chaque intervention est mesurée, chaque ouvrage dessiné puis exécuté avec la rigueur d’un atelier — pas d’à-peu-près, jamais." },
  { n: '02', label: 'Sécurité', body: "Serrures haute sûreté, blindages, vitrages de sécurité : nous protégeons ce qui compte, particuliers et professionnels." },
  { n: '03', label: 'Sur-mesure', body: "Portails, garde-corps, verrières, escaliers — fabriqués à la main, adaptés au lieu et à son architecture." },
  { n: '04', label: 'Discrétion', body: "Un chantier bien mené s’oublie. Nous travaillons avec méthode, propreté et respect des habitants." },
];

export const REASONS = [
  { title: 'Intervention rapide', body: "Nous organisons chaque prise en charge avec sérieux et sans précipitation." },
  { title: 'Travail soigné', body: "Finitions, ajustements et propreté du chantier sont notre signature." },
  { title: 'Solutions sur mesure', body: "Chaque projet est étudié individuellement, du dessin à la pose." },
  { title: 'Devis clair', body: "Prestations, matériaux et délais présentés en toute transparence." },
  { title: 'Matériaux de qualité', body: "Aciers, quincailleries et vitrages sélectionnés pour leur durabilité." },
  { title: 'Accompagnement personnalisé', body: "Un interlocuteur dédié, du premier contact à la livraison." },
];

export const REAL_CATEGORIES = [
  {
    slug: 'serrurerie',
    title: 'Serrurerie',
    subtitle: 'Installation, remplacement et sécurisation de serrures.',
    image: '/serrurerie-hero.png',
    detailImage: '/serrurerie-hero.png',
    detailTitle: 'Installation et remplacement de serrures',
    detailSubtitle: "Installation, remplacement et sécurisation de serrures pour particuliers et professionnels. Chaque intervention est réalisée avec précision, en utilisant des équipements de qualité afin de garantir sécurité, fiabilité et durabilité.",
  },
  {
    slug: 'metallerie',
    title: 'Métallerie',
    subtitle: 'Créations métalliques sur mesure.',
    image: '/metallerie-hero.png',
    detailImage: '/metallerie-hero.png',
    detailTitle: 'Métallerie sur mesure',
    detailSubtitle: "Conception, fabrication et installation d’ouvrages métalliques sur mesure : escaliers, garde-corps, structures acier, portails et autres réalisations adaptées aux besoins des particuliers comme des professionnels. Chaque projet est réalisé avec précision, qualité et exigence.",
    gallery: [
      { type: 'image', src: '/gallery/metallerie/photo-1.webp', alt: 'Verrière atelier en acier noir — porte pivotante' },
      { type: 'video', src: '/gallery/metallerie/video-1.mp4' },
      { type: 'image', src: '/gallery/metallerie/photo-2.jpg', alt: 'Escalier métallique sur mesure — atelier Ponthieu' },
      { type: 'video', src: '/gallery/metallerie/video-2.mp4' },
      { type: 'video', src: '/gallery/metallerie/video-3.mp4' },
    ],
  },
  {
    slug: 'vitrerie',
    title: 'Vitrerie',
    subtitle: 'Pose et remplacement de vitrages.',
    image: '/vitrerie-hero.png',
    detailImage: '/vitrerie-hero.png',
    detailTitle: 'Vitrerie sur mesure',
    detailSubtitle: "Installation, remplacement et réparation de vitrages pour les particuliers et les professionnels. Nous intervenons sur tous types de vitrages avec des finitions soignées, des matériaux de qualité et une attention particulière portée à la sécurité, à l’esthétique et à la durabilité.",
    gallery: [
      { type: 'image', src: '/gallery/vitrerie/photo-1.webp', alt: 'Verrière intérieure sur mesure — porte en verre et acier noir' },
      { type: 'video', src: '/gallery/vitrerie/video-1.mp4' },
      { type: 'video', src: '/gallery/vitrerie/video-2.mp4' },
      { type: 'video', src: '/gallery/vitrerie/video-3.mp4' },
      { type: 'video', src: '/gallery/vitrerie/video-4.mp4' },
    ],
  },
  {
    slug: 'renovation',
    title: 'Rénovation',
    subtitle: 'Travaux de rénovation intérieure et extérieure.',
    image: IMG.haussmann2,
    detailImage: IMG.haussmann2,
    detailTitle: 'Rénovation',
    detailSubtitle: 'Travaux de rénovation intérieure et extérieure.',
    hideDetail: true,
  },
  {
    slug: 'depannage',
    title: 'Dépannage',
    subtitle: 'Interventions rapides 7j/7.',
    image: '/depannage-hero.png',
    detailImage: '/depannage-hero.png',
    detailTitle: 'Dépannage d’urgence',
    detailSubtitle: "Notre équipe intervient rapidement pour tous vos besoins en dépannage : ouverture de porte, remplacement de serrure, mise en sécurité après effraction, réparation et interventions d’urgence. Nous garantissons une prise en charge rapide, un travail soigné et des solutions adaptées à chaque situation.",
  },
];

export const REALISATIONS = [
  { id: 'r1', title: 'Serrure multipoints A2P**', category: 'serrurerie', city: 'Paris 8e', date: '2025', img: IMG.lock, description: "Remplacement complet et pose d’un cylindre haute sûreté sur porte palière d’un immeuble haussmannien." },
  { id: 'r2', title: 'Verrière atelier intérieure', category: 'metallerie', city: 'Paris 16e', date: '2025', img: IMG.glassArch, description: "Verrière en acier noir mat, 3,20 m de long, séparation salon / cuisine avec vitrage feuilleté." },
  { id: 'r3', title: 'Garde-corps métallique', category: 'metallerie', city: 'Paris 9e', date: '2025', img: IMG.stairs, description: "Garde-corps sur mesure, acier brossé, pour escalier intérieur duplex." },
  { id: 'r4', title: 'Double vitrage feuilleté', category: 'vitrerie', city: 'Paris 8e', date: '2025', img: IMG.glassBuilding, description: "Remplacement de vitrage cassé, vitrage de sécurité SP10 posé en 48h." },
  { id: 'r5', title: 'Blindage de porte', category: 'renovation', city: 'Paris 17e', date: '2024', img: IMG.brass, description: "Blindage complet, serrure 5 points, cornière anti-pince, finition laquée." },
  { id: 'r6', title: 'Ouverture après effraction', category: 'depannage', city: 'Paris 8e', date: '2025', img: IMG.heroDoor, description: "Sécurisation d’urgence, remplacement de serrure et pose d’une nouvelle cornière anti-effraction." },
  { id: 'r7', title: 'Rénovation portail acier', category: 'metallerie', city: 'Neuilly-sur-Seine', date: '2024', img: IMG.welder, description: "Reprise complète, décapage, thermolaquage et remise en jeu des ferrures." },
  { id: 'r8', title: 'Vitrine commerciale', category: 'vitrerie', city: 'Paris 8e', date: '2024', img: IMG.haussmann2, description: "Vitrine feuilletée anti-effraction pour boutique rue de Ponthieu." },
];

export const REAL_FILTERS = [
  { slug: 'all', label: 'Toutes les réalisations' },
  { slug: 'serrurerie', label: 'Serrurerie' },
  { slug: 'metallerie', label: 'Métallerie' },
  { slug: 'vitrerie', label: 'Vitrerie' },
  { slug: 'renovation', label: 'Rénovation' },
  { slug: 'depannage', label: 'Dépannage' },
];
